<template>
    <div class="vx-row">
        <div class="vx-col w-full">
            <vs-tabs position="top" id="customer-profile-tabs" class="w-full">
                <vs-tab label="Snapshot">
                    <CustomerCrmSnapshotHome :account_currency="account_currency"/>
                </vs-tab>
                <vs-tab label="Contact">
                    <CustomerCrmContactHome />
                </vs-tab>
                <vs-tab label="Opportunity Pipeline">
                    <CustomerCrmOpportunityList/>
                </vs-tab>
                <vs-tab label="Marketing Campaigns">
                    <CustomerCrmCampaignList/>
                </vs-tab>
                <vs-tab label="Enquiries">
                    <CustomerEnquiriesList/>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>
<script>
import CustomerCrmContactHome from './customer-crm-contact/CustomerCrmContactHome.vue'
import CustomerCrmOpportunityList from './customer-crm-opportunity-pipeline/CustomerCrmOpportunityList.vue'
import CustomerCrmSnapshotHome from './customer-crm-snapshot/CustomerCrmSnapshotHome.vue'
import CustomerCrmCampaignList from './customr-crm-campaign/CustomerCrmCampaignList.vue'
import CustomerEnquiriesList from './customer-crm-enquiries/CustomerEnquiriesList.vue'

export default {
    name: 'CustomerCrmHome',
    props: {
        account_currency: {
            default: 'GBP'
        }
    },
    components: {
        CustomerCrmContactHome,
        CustomerCrmOpportunityList,
        CustomerCrmSnapshotHome,
        CustomerCrmCampaignList,
        CustomerEnquiriesList
    }
}
</script>
<style lang="">
    
</style>